<mat-dialog-content style="height: 43vh;">
    <div layout="row" layout-align="center center">
        <div style="margin-bottom: 2%;">
            <strong >{{titulo}}</strong>
        </div>
        <table style="width: 100%;">
            <tr>
                <td style="width:85%;">
                    <mat-form-field style="width: 100%;">
                        <input matInput placeholder="Localidad" 
                            [(ngModel)]=nombre>
                    </mat-form-field>
                </td>
                <td style="width:5%;"></td>
                <td style="width:10%;">
                    <mat-form-field style="width: 100%;">
                        <input matInput placeholder="codPostal" 
                            [(ngModel)]=codPostal>
                    </mat-form-field>
                </td>
            </tr>
        </table>
        <div [hidden]="nombreProvincia!=''">
            <mat-form-field style="width: 80%; font-size: 2.0vh;">
                <input matInput placeholder="Tipo de domicilio"
                    [(ngModel)]=txtProvincia autocomplete="off"
                    (keydown.enter)="buscarProvincia()">
            </mat-form-field>
            <i class="fas fa-search" style="font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                margin-top: 0px;" (click)="buscarProvincia()"
                matTooltip="Buscar provincia">
            </i>
        </div>
        <div [hidden]="nombreProvincia==''" style="text-align: start; margin-right: 5px; margin-bottom: 20px;">
            <i class="fas fa-trash" style=" margin-right: 5px;
                font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                margin-top: 0px;" (click)="eliminarProvincia()"
                matTooltip="Eliminar provincia">
            </i>
            <mat-label>{{nombreProvincia}}</mat-label>
        </div>
        <div>
            <mat-checkbox style="margin-bottom: 20px;" color="primary"
                [(ngModel)]=habilitado>Habilitado
            </mat-checkbox>
        </div>
    </div>
</mat-dialog-content>
<div style="text-align: center;">
    <table style="width: 100%; text-align: center;">
        <tr>
            <td style="width: 30%;">
                <button mat-raised-button class="btn-agregar" (click)="cerrar('cancela')">
                    <i class="fas fa-arrow-circle-left fa-1x" style="width: 20px; margin-right:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                    Cancelar
                </button>
            </td>
            <td style="width: 20%;"></td>
            <td style="width: 30%;">
                <button mat-raised-button class="btn-agregar" (click)="almacenar()" style="margin-left: 30px;">
                    <i class="fas fa-save fa-1x" style="width: 20px; margin-right:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                    Almacenar
                </button>
            </td>
        </tr>
    </table>
</div>
